import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { INotificationTemplate, INotificationTemplateEdit, INotificationTemplateListItem } from '../models/NotificationTemplate';

import { environment as ENV } from '../../environments/environment';

/**
 * Notification template service
 */
@Injectable({ providedIn: "root" })
export class NotificationTemplateService {
    constructor(public http: HttpClient) { }

    public get apiUrl(): string { return `${ENV.apiUrl}/notificationTemplates` }

    get(): Observable<INotificationTemplateListItem[]> {
        return this.http.get<INotificationTemplateListItem[]>(this.apiUrl);
    }

    getById(id: number): Observable<INotificationTemplate> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.get<INotificationTemplate>(url);
    }

    create(model: INotificationTemplateEdit): Observable<number> {
        const url = `${this.apiUrl}`;
        return this.http.post<number>(url, model);
    }

    update(id: number, model: INotificationTemplateEdit): Observable<number> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.put<number>(url, model);
    }

    delete(id: number): Observable<any> {
        const url = `${this.apiUrl}/${id}`;
        return this.http.delete(url);
    }
}
